import { Calendar } from "lucide-react";
import { resolveImageUrl, PLACEHOLDER } from "@/utils/imageUrl";
import { getMonthlyReports, productProfit } from "@/utils/adminHelpers";

export const ReportsPanel = ({ soldProducts, toUSD }) => {
  const reports = getMonthlyReports(soldProducts);

  if (reports.length === 0) {
    return (
      <div className="text-center py-20 glass-card" data-testid="reports-section">
        <Calendar className="w-10 h-10 text-[#A0A0A0] mx-auto mb-3" />
        <p className="text-[#A0A0A0]">No hay ventas registradas</p>
      </div>
    );
  }

  return (
    <div className="space-y-6" data-testid="reports-section">
      {reports.map((month, idx) => (
        <div key={month.label} className="glass-card overflow-hidden" data-testid={`report-month-${idx}`}>
          <div className="p-4 border-b border-white/5 flex flex-wrap items-center justify-between gap-3">
            <h3 className="font-oswald text-lg font-bold text-white capitalize">{month.label}</h3>
            <div className="flex gap-4 text-sm">
              <span className="text-[#A0A0A0]">{month.products.length} vendido{month.products.length !== 1 ? "s" : ""}</span>
              <span className="text-white">Venta: <span className="text-[#00FF66] font-semibold">${month.revenue.toFixed(0)}</span> <span className="text-[#A0A0A0] text-xs">(${toUSD(month.revenue)} USD)</span></span>
              <span className="text-white">Ganancia: <span className="text-[#00FF66] font-semibold">${month.profit.toFixed(0)}</span> <span className="text-[#A0A0A0] text-xs">(${toUSD(month.profit)} USD)</span></span>
            </div>
          </div>
          <div className="divide-y divide-white/5">
            {month.products.map(p => (
              <div key={p.id} className="flex items-center gap-3 p-3">
                <img src={resolveImageUrl(p.image_url) || PLACEHOLDER} alt={p.name} className="w-10 h-10 rounded-lg object-cover bg-[#050505]" />
                <div className="flex-1 min-w-0">
                  <p className="text-sm text-white truncate">{p.name}</p>
                  <p className="text-xs text-[#A0A0A0]">{p.brand} &bull; {p.size}</p>
                </div>
                <div className="text-right">
                  <p className="text-sm text-[#00FF66] font-semibold">${p.sale_price}</p>
                  <p className="text-xs text-[#A0A0A0]">+${productProfit(p).toFixed(0)} ganancia</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};
